import React from "react";

const IconBalconyPorch = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.5484 27.3199H6.45277V0.679812C6.45277 0.304375 6.75715 0 7.13265 0H24.8685C25.2439 0 25.5483 0.304375 25.5483 0.679812V27.3198H25.5484V27.3199Z"
      fill="url(#paint0_linear_2_222)"
    />
    <path
      d="M25.5472 8.68867L21.5962 4.73773C20.1907 3.25142 18.2016 2.32261 15.9993 2.32261C11.7508 2.32261 8.29434 5.77904 8.29434 10.0276V27.3198H25.5471L25.5472 8.68867Z"
      fill="url(#paint1_linear_2_222)"
    />
    <path
      d="M23.2344 27.3198H8.76562V10.0276C8.76562 6.03214 12.0046 2.79321 16 2.79321C19.9954 2.79321 23.2344 6.03214 23.2344 10.0276V27.3198Z"
      fill="url(#paint2_linear_2_222)"
    />
    <path
      d="M16 2.79321V27.3198H23.2344V10.0276C23.2344 6.03208 19.9954 2.79321 16 2.79321Z"
      fill="url(#paint3_linear_2_222)"
    />
    <path
      d="M21.0682 26.3127H18.1677C17.7717 26.3127 17.4507 25.9917 17.4507 25.5957V18.6411C17.4507 18.2451 17.7717 17.9241 18.1677 17.9241H21.0682C21.4642 17.9241 21.7852 18.2451 21.7852 18.6411V25.5957C21.7852 25.9917 21.4641 26.3127 21.0682 26.3127Z"
      fill="url(#paint4_linear_2_222)"
    />
    <path
      d="M23.2343 10.0279V16.6239H16V2.79301C19.9952 2.79301 23.2343 6.03213 23.2343 10.0279Z"
      fill="url(#paint5_linear_2_222)"
    />
    <path
      d="M15.9993 2.32261C11.7508 2.32261 8.29434 5.77904 8.29434 10.0276V27.3198H9.23553V10.0275C9.23553 6.45617 12.0179 3.52286 15.5287 3.28036V27.3197H16.4699V17.0944H22.7631V27.3197H23.7043V10.0275C23.7043 5.77898 20.2479 2.32261 15.9993 2.32261ZM16.4699 8.77386H19.1459V11.9929H16.4699V8.77386ZM16.4699 7.83273V3.28042C17.4305 3.34673 18.3365 3.61454 19.1459 4.04186V7.83273H16.4699V7.83273ZM20.0871 8.77386H22.6462C22.7227 9.18023 22.7631 9.59929 22.7631 10.0275V11.9929H20.0871V8.77386ZM22.3974 7.83273H20.0872V4.64254C21.1435 5.44642 21.9572 6.55336 22.3974 7.83273ZM16.4699 12.9341H19.1459V16.1532H16.4699V12.9341ZM20.0871 16.1532V12.9341H22.7631V16.1532H20.0871Z"
      fill="white"
    />
    <path
      d="M27.5776 28.88H4.42277C4.13933 28.88 3.90964 28.6502 3.90964 28.3668V27.8331C3.90964 27.5497 4.13939 27.32 4.42277 27.32H27.5776C27.861 27.32 28.0907 27.5498 28.0907 27.8331V28.3668C28.0908 28.6502 27.861 28.88 27.5776 28.88Z"
      fill="url(#paint6_linear_2_222)"
    />
    <path
      d="M25.1901 30.4398H6.80927C6.26964 30.4398 5.83221 30.0023 5.83221 29.4627V28.8798H26.1672V29.4627C26.1673 30.0023 25.7298 30.4398 25.1901 30.4398Z"
      fill="url(#paint7_linear_2_222)"
    />
    <path
      d="M23.5924 31.9998H8.40861C7.86899 31.9998 7.43155 31.5624 7.43155 31.0227V30.4398H24.5695V31.0227C24.5695 31.5624 24.132 31.9998 23.5924 31.9998Z"
      fill="url(#paint8_linear_2_222)"
    />
    <path
      d="M26.1679 28.8799V29.4629C26.1679 30.0025 25.7305 30.4399 25.1909 30.4399H7.3935L5.83337 28.8798H26.1679V28.8799Z"
      fill="url(#paint9_linear_2_222)"
    />
    <path
      d="M24.5694 30.4399V31.0229C24.5694 31.5625 24.132 31.9999 23.5924 31.9999H8.95347L7.43172 30.4782V30.4399H24.5694Z"
      fill="url(#paint10_linear_2_222)"
    />
    <path
      d="M9.22504 26.4772C9.22504 26.7747 9.16873 27.0585 9.06604 27.3194H4.78298C4.6803 27.0586 4.62399 26.7747 4.62399 26.4772C4.62399 26.1876 4.67736 25.9107 4.77511 25.6557C5.10586 24.7905 5.94342 24.1768 6.92442 24.1768C7.90542 24.1768 8.7431 24.7905 9.07373 25.6557C9.1716 25.9107 9.22504 26.1876 9.22504 26.4772Z"
      fill="url(#paint11_linear_2_222)"
    />
    <path
      d="M10.7083 26.7085C10.7083 26.9242 10.6674 27.1301 10.593 27.3194H7.48608C7.41158 27.1301 7.37077 26.9242 7.37077 26.7085C7.37077 26.4984 7.40945 26.2976 7.48045 26.1125C7.72033 25.4849 8.32795 25.0397 9.03957 25.0397C9.7512 25.0397 10.3588 25.4849 10.5987 26.1125C10.6696 26.2976 10.7083 26.4984 10.7083 26.7085Z"
      fill="url(#paint12_linear_2_222)"
    />
    <path
      d="M27.3759 26.3126C27.3759 26.6683 27.3086 27.0078 27.1858 27.3199H22.0633C21.9404 27.0079 21.8731 26.6684 21.8731 26.3126C21.8731 25.9662 21.937 25.6351 22.0539 25.33C22.4495 24.2952 23.4513 23.5612 24.6246 23.5612C25.7979 23.5612 26.7997 24.2952 27.1952 25.33C27.3121 25.6351 27.3759 25.9663 27.3759 26.3126Z"
      fill="url(#paint13_linear_2_222)"
    />
    <path
      d="M28.3838 18.323H3.61713C2.959 18.323 2.42356 18.8584 2.42356 19.5166C2.42356 20.1747 2.95894 20.7101 3.61713 20.7101H4.07213C4.47932 20.7101 4.81063 20.3788 4.81063 19.9716C4.81063 19.5643 4.47932 19.233 4.07213 19.233H3.61713C3.4785 19.233 3.36613 19.3454 3.36613 19.484C3.36613 19.6227 3.4785 19.735 3.61713 19.735H4.07213C4.20257 19.735 4.30869 19.8412 4.30869 19.9717C4.30869 20.102 4.20257 20.2082 4.07213 20.2082H3.61713C3.23575 20.2082 2.92556 19.898 2.92556 19.5167C2.92556 19.1353 3.23575 18.8252 3.61713 18.8252H5.1705V27.32H5.67244V24.6657C6.16594 25.4229 6.99094 25.9447 7.94032 26.0237V27.3199H8.44225V26.0237C9.08881 25.9699 9.67763 25.7108 10.1436 25.3116C10.6094 25.7108 11.1983 25.9699 11.8449 26.0237V27.3199H12.3468V26.0237C12.9934 25.9699 13.5822 25.7108 14.0481 25.3116C14.5139 25.7108 15.1028 25.9699 15.7493 26.0237V27.3199H16.2513V26.0237C16.8978 25.9699 17.4866 25.7108 17.9525 25.3116C18.4184 25.7108 19.0072 25.9699 19.6538 26.0237V27.3199H20.1557V26.0237C20.8023 25.9699 21.3911 25.7108 21.857 25.3116C22.3229 25.7108 22.9118 25.9699 23.5583 26.0237V27.3199H24.0603V26.0237C25.0096 25.9447 25.8346 25.423 26.3281 24.6657V27.3199H26.8301V18.825H28.3834C28.7648 18.825 29.075 19.1352 29.075 19.5166C29.075 19.8979 28.7648 20.2081 28.3834 20.2081H27.9284C27.798 20.2081 27.6919 20.102 27.6919 19.9715C27.6919 19.8411 27.798 19.7349 27.9284 19.7349H28.3834C28.5221 19.7349 28.6344 19.6225 28.6344 19.4839C28.6344 19.3453 28.5221 19.2329 28.3834 19.2329H27.9284C27.5213 19.2329 27.1899 19.5642 27.1899 19.9715C27.1899 20.3787 27.5213 20.71 27.9284 20.71H28.3834C29.0416 20.71 29.577 20.1746 29.577 19.5165C29.5773 18.8585 29.0419 18.323 28.3838 18.323ZM22.8988 22.7788C22.8461 22.1452 22.5965 21.5668 22.2108 21.1054C22.6448 20.7443 23.2021 20.5267 23.8095 20.5267C25.105 20.5267 26.1737 21.5161 26.3 22.7789H22.8988V22.7788ZM21.8573 24.5938C21.5624 24.2264 21.3684 23.7747 21.319 23.2808H22.3954C22.3461 23.7747 22.1521 24.2264 21.8573 24.5938ZM9.60538 23.2808H10.6818C10.6324 23.7747 10.4385 24.2264 10.1436 24.5938C9.84875 24.2264 9.65475 23.7747 9.60538 23.2808ZM5.70081 22.7788C5.82713 21.516 6.89581 20.5267 8.19131 20.5267C8.79869 20.5267 9.35606 20.7443 9.79 21.1053C9.40431 21.5668 9.15475 22.1452 9.10207 22.7788H5.70081V22.7788ZM18.9943 22.7788C18.9416 22.1452 18.692 21.5668 18.3063 21.1054C18.7403 20.7443 19.2976 20.5267 19.905 20.5267C20.5124 20.5267 21.0698 20.7443 21.5037 21.1054C21.118 21.5668 20.8684 22.1452 20.8158 22.7788H18.9943ZM15.0897 22.7788C15.037 22.1452 14.7874 21.5668 14.4018 21.1054C14.8357 20.7443 15.3931 20.5267 16.0004 20.5267C16.6078 20.5267 17.1652 20.7443 17.5991 21.1054C17.2134 21.5668 16.9639 22.1452 16.9112 22.7788H15.0897ZM11.1851 22.7788C11.1324 22.1452 10.8829 21.5668 10.4972 21.1054C10.9311 20.7443 11.4885 20.5267 12.0959 20.5267C12.7033 20.5267 13.2606 20.7443 13.6946 21.1054C13.3089 21.5668 13.0593 22.1452 13.0066 22.7788H11.1851ZM14.0481 21.4658C14.343 21.8332 14.537 22.285 14.5864 22.7788H13.5099C13.5593 22.285 13.7533 21.8332 14.0481 21.4658ZM17.9528 21.4658C18.2476 21.8332 18.4416 22.285 18.491 22.7788H17.4146C17.4639 22.285 17.6578 21.8332 17.9528 21.4658ZM19.654 20.036C19.0074 20.0897 18.4186 20.3488 17.9528 20.7481C17.4869 20.3488 16.898 20.0898 16.2515 20.036V18.825H19.6541L19.654 20.036ZM15.7494 20.036C15.1029 20.0897 14.5141 20.3488 14.0482 20.7481C13.5823 20.3488 12.9935 20.0898 12.3469 20.036V18.825H15.7495V20.036H15.7494ZM11.8449 20.036C11.1983 20.0897 10.6095 20.3488 10.1436 20.7481C9.67769 20.3488 9.08881 20.0898 8.44225 20.036V18.825H11.8449V20.036V20.036ZM10.1436 21.4658C10.4385 21.8332 10.6325 22.285 10.6819 22.7788H9.60544C9.65475 22.285 9.84875 21.8332 10.1436 21.4658ZM11.1851 23.2808H13.0066C13.0593 23.9144 13.3089 24.4928 13.6946 24.9542C13.2606 25.3153 12.7033 25.5329 12.0959 25.5329C11.4885 25.5329 10.9311 25.3153 10.4972 24.9542C10.8829 24.4928 11.1324 23.9144 11.1851 23.2808ZM13.5099 23.2808H14.5863C14.5369 23.7747 14.343 24.2264 14.0481 24.5938C13.7533 24.2264 13.5593 23.7747 13.5099 23.2808ZM15.0897 23.2808H16.9113C16.9639 23.9144 17.2135 24.4928 17.5992 24.9542C17.1653 25.3153 16.6079 25.5329 16.0005 25.5329C15.3931 25.5329 14.8358 25.3153 14.4018 24.9542C14.7874 24.4928 15.037 23.9144 15.0897 23.2808ZM17.4144 23.2808H18.4909C18.4415 23.7747 18.2476 24.2264 17.9526 24.5938C17.6578 24.2264 17.4639 23.7747 17.4144 23.2808ZM18.9943 23.2808H20.8158C20.8684 23.9144 21.118 24.4928 21.5037 24.9542C21.0698 25.3153 20.5124 25.5329 19.905 25.5329C19.2976 25.5329 18.7403 25.3153 18.3063 24.9542C18.692 24.4928 18.9416 23.9144 18.9943 23.2808ZM21.319 22.7788C21.3684 22.2849 21.5623 21.8332 21.8573 21.4658C22.1521 21.8332 22.3461 22.285 22.3955 22.7788H21.319ZM23.5586 20.036C22.912 20.0897 22.3232 20.3488 21.8573 20.7481C21.3914 20.3488 20.8025 20.0898 20.1559 20.036V18.825H23.5586V20.036ZM7.94032 18.825V20.036C6.991 20.115 6.16594 20.6367 5.67244 21.394V18.825H7.94032ZM5.70081 23.2808H9.10213C9.15481 23.9144 9.40438 24.4928 9.79006 24.9542C9.35613 25.3153 8.79875 25.5329 8.19138 25.5329C6.89581 25.533 5.82713 24.5436 5.70081 23.2808ZM23.8096 25.533C23.2022 25.533 22.6448 25.3153 22.2109 24.9543C22.5966 24.4928 22.8461 23.9145 22.8988 23.2808H26.3001C26.1738 24.5436 25.1051 25.533 23.8096 25.533ZM26.3284 21.394C25.8349 20.6367 25.0099 20.1149 24.0605 20.036V18.825H26.3284V21.394Z"
      fill="#654E48"
    />
    <path
      d="M7.38272 9.06579C7.38272 5.29686 9.80228 2.09361 13.1726 0.923107H7.99684C7.65215 0.923107 7.37278 1.20248 7.37278 1.54717L7.38272 9.06579Z"
      fill="url(#paint14_linear_2_222)"
    />
    <path
      d="M24.004 0.923191H18.8281C22.1985 2.09369 24.6181 5.29694 24.6181 9.06588L24.6281 1.54725C24.628 1.2025 24.3486 0.923191 24.004 0.923191Z"
      fill="url(#paint15_linear_2_222)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2_222"
        x1="16.0002"
        y1="5.96387"
        x2="16.0002"
        y2="31.2333"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE7A5" />
        <stop offset="0.966" stopColor="#FFBF5C" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2_222"
        x1="21.9276"
        y1="20.5662"
        x2="10.2573"
        y2="12.7859"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5D00" stopOpacity="0" />
        <stop offset="1" stopColor="#D54003" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2_222"
        x1="15.9997"
        y1="31.7075"
        x2="15.9997"
        y2="15.2285"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#654E48" />
        <stop offset="1" stopColor="#503837" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2_222"
        x1="21.7002"
        y1="6.15697"
        x2="15.7847"
        y2="31.4264"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE7A5" />
        <stop offset="0.966" stopColor="#FFBF5C" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2_222"
        x1="16.4597"
        y1="6.17556"
        x2="21.4648"
        y2="31.445"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE7A5" />
        <stop offset="0.966" stopColor="#FFBF5C" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2_222"
        x1="19.6167"
        y1="15.7142"
        x2="19.6167"
        y2="7.42329"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#654E48" />
        <stop offset="1" stopColor="#503837" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2_222"
        x1="15.9999"
        y1="27.6745"
        x2="15.9999"
        y2="29.4314"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5D00" />
        <stop offset="1" stopColor="#D54003" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_2_222"
        x1="15.9994"
        y1="29.2348"
        x2="15.9994"
        y2="30.991"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5D00" />
        <stop offset="1" stopColor="#D54003" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_2_222"
        x1="16.0002"
        y1="30.7946"
        x2="16.0002"
        y2="32.5508"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5D00" />
        <stop offset="1" stopColor="#D54003" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_2_222"
        x1="15.7252"
        y1="28.0985"
        x2="14.7182"
        y2="25.2381"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D54003" stopOpacity="0" />
        <stop offset="1" stopColor="#A40002" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_2_222"
        x1="15.9416"
        y1="30.316"
        x2="14.5437"
        y2="26.9034"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D54003" stopOpacity="0" />
        <stop offset="1" stopColor="#A40002" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_2_222"
        x1="5.62726"
        y1="25.0454"
        x2="8.46579"
        y2="27.8839"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9EB644" />
        <stop offset="1" stopColor="#738611" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_2_222"
        x1="8.09859"
        y1="25.6697"
        x2="10.1572"
        y2="27.729"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9EB644" />
        <stop offset="1" stopColor="#738611" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_2_222"
        x1="23.0725"
        y1="24.5999"
        x2="26.4676"
        y2="27.9949"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9EB644" />
        <stop offset="1" stopColor="#738611" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_2_222"
        x1="10.2725"
        y1="6.74375"
        x2="10.2725"
        y2="-3.27015"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE7A5" />
        <stop offset="0.966" stopColor="#FFBF5C" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_2_222"
        x1="21.7277"
        y1="6.74377"
        x2="21.7277"
        y2="-3.27013"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE7A5" />
        <stop offset="0.966" stopColor="#FFBF5C" />
      </linearGradient>
    </defs>
  </svg>
);

export default IconBalconyPorch;
